import { useEffect, useState } from "react";
import { FaMinus } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa6";
import CalvinLogo from "../../assets/Images/Calvin-Group-Logo.svg";
import RightIcon from "../../assets/Images/rightIcon.svg";
import MachineImg from "../../assets/Images/machineImg.svg";
import NoImgIcon from "../../assets/png/no-image-icon.png";
import { currencyFormat, detailPageURL, logoutFun } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import Icon from "../icon/Icon";
import { addWatchList } from "../../services/vizyBilityServices";
import { toast } from "react-toastify";
import { useMsal } from "@azure/msal-react";
import { DarkLogo } from "../../assets/images";

const SimilarCard = ({ data, listCard }) => {
  const { instance, accounts } = useMsal();
  const [cardLoading, setCardLoading] = useState(false);
  const Logout = localStorage.getItem("getAzureUserData") || localStorage.getItem("azuretoken");
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;
  const [watchList, setWatchList] = useState(data?.is_active_watchlist || false);
  const navigate = useNavigate();
  // State for the custom checkbox
  const [checkboxState, setCheckboxState] = useState("not-selected");

  // Handle checkbox click to cycle through states
  const handleCheckboxClick = () => {
    setCheckboxState((prevState) => {
      if (prevState === "not-selected") return "selected";
      if (prevState === "selected") return "minus";
      return "not-selected";
    });
  };
  const handleOnPressCall = () => {
    if (data?.dealer?.contact_user?.phone) {
      return `callto:${data?.dealer?.contact_user?.phone}`;
    } else if (data?.dealer?.contact_user?.email) {
      return `mailto:${data?.dealer?.contact_user?.email}`;
    } else {
      return "javascript:void(0)";
    }
  };
  const Rpath = detailPageURL(data);

  const handelWatchList = () => {
    setCardLoading(true);
    let payload = {
      assetId: data?.id,
      assetAdvertisementId: data?.assetAdvertisementId,
      contactId: azureUserInfo?.ContactId,
    };
    if (watchList) {
      payload = {
        ...payload,
        active: false,
      };
    } else {
      payload = {
        ...payload,
        active: true,
      };
    }

    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    addWatchList(payload, header, instance, accounts)
      .then((res) => {
        setWatchList(!watchList);
        setCardLoading(false);
        if (watchList) {
          toast.success("Successfully removed from watchlist!");
        } else {
          toast.success("Successfully added to watchlist!");
        }
      })
      .catch((err) => {
        setCardLoading(false);
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          toast.error("you are logged out, login again to add machines to watchlist.");
          logoutFun(instance);
        } else {
          toast.error(err?.data);
        }
      });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <div className="shadow-lg relative group">
        <div
          onClick={() => navigate(Rpath, { state: { assetAdvertisementId: data?.assetAdvertisementId } })}
          className="cursor-pointer"
        >
          <img
            src={data?.primary_image.url || NoImgIcon}
            alt="Machine"
            width="100%"
            className="object-cover rounded-t-lg h-[200px]"
          />
        </div>

        <div className="p-[10px]">
          <div className="text-[#161412] text-[18px] font-bold break-words">
            {data?.year}&nbsp;
            {data?.model?.manufacturer?.name}&nbsp;
            {data?.model?.number}
          </div>
          <div className="text-[#161412] text-[15px] break-words">{data?.machine_type?.name}</div>
          <div className="text-[#161412] text-[15px]">
            {" "}
            {data?.meter_reading ? data?.meter_reading : "N/A"}{" "}
            {data?.meter_reading_unit ? data?.meter_reading_unit : "Hours"}
          </div>
        </div>

        <div className="mt-[10px] flex justify-end items-center p-[10px] sm:flex-row flex-col">
          <div className="flex flex-col items-center sm:items-end w-full">
            <div className="text-[#161412] text-[18px] font-bold">
              {" "}
              {data?.advertised_price?.fractional != 0 ? (
                <>
                  {data?.advertised_price?.currency?.symbol}
                  {currencyFormat(Number(data?.advertised_price?.fractional))}
                </>
              ) : (
                <a
                  href={handleOnPressCall()}
                  className="bg-[#FEBA06] py-[2px] text-[18px]  px-1 rounded disable:hover mb-[10px]"
                >
                  Call for Pricing
                </a>
              )}
            </div>

            <div
              className={`flex ${
                data?.advertising_type?.trim().toLowerCase() == "consignment"
                  ? "justify-between"
                  : data?.company_info?.logo?.url
                  ? "justify-between"
                  : "justify-end"
              } items-center sm:flex-row flex-col  w-full`}
            >
              {data?.advertising_type?.trim().toLowerCase() == "consignment" ? (
                <div>
                  <img src={DarkLogo} alt="Calvin Logo" className="max-h-[20px]" />
                </div>
              ) : data?.company_info?.logo?.url ? (
                <div>
                  <img src={data?.company_info?.logo?.url} alt="Calvin Logo" className="max-h-[20px]" />
                </div>
              ) : null}
              <div className="flex flex-col items-center sm:items-end">
                <div className="text-[#161412] text-[14px] flex">
                  <img src={RightIcon} alt="Right Icon" className="mr-1" />
                  <b>
                    {data?.dealer?.name} {data?.dealer?.address ? `| ${data?.dealer?.address}` : null}
                  </b>
                </div>
                <div className="text-[#161412] text-[14px] font-bold">
                  {data?.dealer?.contact_user?.phone ? (
                    <a href={`callto:${data?.dealer?.contact_user?.phone}`}>{data?.dealer?.contact_user?.phone}</a>
                  ) : null}
                </div>
                <div className="text-[#161412] text-[14px] font-bold">
                  {data?.dealer?.contact_user?.email ? (
                    <a href={`mailto:${data?.dealer?.contact_user?.email}`}>{data?.dealer?.contact_user?.email}</a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Custom Checkbox */}
        {/* <div className="flex justify-center mt-4 absolute top-[-4px] right-3">
          <div
            className={`w-[20px] h-[20px] rounded cursor-pointer flex items-center justify-center ${
              checkboxState === "selected"
                ? "bg-[#FEBA06]"
                : checkboxState === "minus"
                ? "border-[#FEBA06] bg-transparent"
                : "border-[#FEBA06] bg-transparent"
            } border-2 border-[#FEBA06]`}
            onClick={() => handleCheckboxClick()}
          >
            {checkboxState === "selected" && (
              <span className="text-[#000] font-bold">
                <FaCheck />
              </span>
            )}
            {checkboxState === "minus" && (
              <span className="text-[#FEBA06] font-bold">
                <FaMinus />
              </span>
            )}
          </div>
        </div> */}
        {Logout && (
          <div className="flex justify-center mt-4 absolute top-[-10px] left-1 opacity-100">
            {cardLoading ? (
              <div className="absolute top-0 left-0 w-[30px] h-[30px] border-2 border-[#feba06] border-dashed rounded-full animate-spin"></div>
            ) : (
              <Icon
                icon={"HeroHeart"}
                className={`text-2xl ${
                  watchList ? "fill-[#FEBA06]" : null
                } w-[30px] h-[30px] text-[#FEBA06] cursor-pointer`}
                onClick={() => handelWatchList()}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default SimilarCard;
